<template>
  <div>
    <v-card>
      <v-card-title
        >全ユーザ管理
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="検索"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="values"
        :search="search"
        :sort-by="sortby"
        :sort-desc="sortdesc"
        :items-per-page="20"
        multi-sort
        class="elevation-1"
      >
        <template v-slot:[`item.state`]="{ item }">
          <v-select
            v-model="item.state"
            :items="authority"
            item-text="auth"
            item-value="id"
            @change="onAuthChange(item)"
          >
          </v-select>
        </template>
        <template v-slot:[`item.isYhbc`]="{ item }">
          <v-select
            v-model="item.isYhbc"
            :items="yhbc"
            item-text
            return-object
            @change="onClubChange(item)"
          >
          </v-select>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline" color="error"
          >権限更新の確認</v-card-title
        >

        <v-card-text>
          他人のアカウントに全権限を与える危険な行為です。故意の変更でなければすぐにキャンセルしてください。
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialog = false">
            キャンセル
          </v-btn>

          <v-btn color="green darken-1" text @click="onContinue()">
            続行
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable no-console */
// eslint-disable-next-line no-unused-vars
import CommonMethods from "@/mixins/CommonMethods.js";

export default {
  components: {},
  mixins: [CommonMethods],
  props: {
    headers: Array,
    values: Array,
    sortby: Array,
    sortdesc: Array,
  },
  watch: {
    values() {
      console.log(this.values);
    },
  },
  data() {
    return {
      url: "",
      title: "",
      search: "",
      auth: null,
      users: [],
      authority: [
        { auth: "Super Admin", id: 0 },
        { auth: "Admin", id: 1 },
        { auth: "User", id: 2 },
        { auth: "Kids", id: 3 },
      ],
      yhbc: [true, false],
      selectValue: null,
      dialog: false,
    };
  },
  methods: {
    onClubChange(value) {
      this.$emit("onClubChange", value);
    },
    onAuthChange(value) {
      this.selectValue = value;
      if (value.state == 0) this.dialog = true;
      else this.onContinue();
    },
    onContinue() {
      this.$emit("onAuthChange", this.selectValue);
    },
  },
};
</script>
